import React from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {setAnnouncementModal} from 'redux/popup/popupSlice';

const TriggerButton = ({referance, text, onApprove, data, activeTab, disabled = false}) => {
	const { popup } = useSelector((state) => state)
	const { triggerPopups } = popup
    const dispatch = useDispatch()
    const handleEventListener = (e) => {
		for (let triggerPopup of triggerPopups) {
			if (referance == triggerPopup.triggerReference) {
				e.preventDefault();
				if(onApprove){
					dispatch(setAnnouncementModal({open:true, content:triggerPopup,onApprove:onApprove }))
				}else{
					dispatch(setAnnouncementModal({open:true, content:triggerPopup}))
				}
				
				
				e.currentTarget.click();
			}
		}
    }
	if (data) {
		return <button id={referance} disabled={disabled} onClick={handleEventListener} className={`navbar-tab-sub ${data.id == 2 ? "address" : "branch"} ${data.id == activeTab ? "navbar-tab-active" : ""}`}>{data.name}</button>
	}
  return (
    <b onClick={handleEventListener}><a id={referance}>{text}</a></b>
  )
}

export default TriggerButton